import * as fromDatatype from '../datatype-library/index';

export interface bl_alg_cc_outbound_task_event_RowInterface {
  guid : fromDatatype.GuidDataFieldInterface; 
  hdr_guid : fromDatatype.GuidDataFieldInterface;
  namespace : fromDatatype.VarcharDatatypeClass;
  module_guid : fromDatatype.GuidDataFieldInterface;
  applet_guid : fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  message_json: fromDatatype.JsonDatatypeInterface;
  created_date : fromDatatype.TimestampTzDatatypeInterface;
  updated_date : fromDatatype.TimestampTzDatatypeInterface;
  completed_date: fromDatatype.TimestampTzDatatypeInterface;
  event_code : fromDatatype.VarcharDatatypeInterface;
  id_user : fromDatatype.VarcharDatatypeInterface;
  id_device : fromDatatype.VarcharDatatypeInterface;
  id_user_agent : fromDatatype.VarcharDatatypeInterface;
  txn_date : fromDatatype.TimestampTzDatatypeInterface;
  foreign_table : fromDatatype.VarcharDatatypeInterface;
  foreign_key : fromDatatype.VarcharDatatypeInterface;
  property_json : fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision : fromDatatype.GuidDataFieldInterface;
  vrsn : fromDatatype.VarcharDatatypeInterface;
}

export class bl_alg_cc_outbound_task_event_RowClass implements bl_alg_cc_outbound_task_event_RowInterface {
  guid : fromDatatype.GuidDataFieldInterface; 
  hdr_guid : fromDatatype.GuidDataFieldInterface;
  namespace : fromDatatype.VarcharDatatypeClass;
  module_guid : fromDatatype.GuidDataFieldInterface;
  applet_guid : fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  message_json: fromDatatype.JsonDatatypeInterface;
  created_date : fromDatatype.TimestampTzDatatypeInterface;
  updated_date : fromDatatype.TimestampTzDatatypeInterface;
  completed_date: fromDatatype.TimestampTzDatatypeInterface;
  event_code : fromDatatype.VarcharDatatypeInterface;
  id_user : fromDatatype.VarcharDatatypeInterface;
  id_device : fromDatatype.VarcharDatatypeInterface;
  id_user_agent : fromDatatype.VarcharDatatypeInterface;
  txn_date : fromDatatype.TimestampTzDatatypeInterface;
  foreign_table : fromDatatype.VarcharDatatypeInterface;
  foreign_key : fromDatatype.VarcharDatatypeInterface;
  property_json : fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision : fromDatatype.GuidDataFieldInterface;
  vrsn : fromDatatype.VarcharDatatypeInterface;
}
